module.exports = __webpack_public_path__ + "img/icon-back-red.9ba8f1a0.svg";